module.exports = __webpack_public_path__ + "img/stock2.5d5534c7.png";